export default __webpack_public_path__ + "static/media/Pistol_2.ea7792d5.png";